<div style="position: relative; height: 100%">
  <map-control
    [alphaIcons]="true"
    [streetViewControlOptions]="mapOptions.streetViewControlOptions"
    [streetViewControl]="mapOptions.streetViewControl"
    [styleClass]="'full-height'"
    [customStyle]="customStyle"
    [destinationIcon]="destinationIcon"
    [organisationIcon]="homeIcon"
    [organisations]="organisations"
    [originIcon]="originIcon"
    [readOnly]="true"
    [tasks]="tasks"
    [zoom]="zoom"
    [lazyLoad]="lazyLoad"
    [alwaysAutofit]="true"
  ></map-control>

  <div class="map-legend">
    <span
      (click)="toggleRoute(task, $event)"
      *ngFor="let task of tasks; let i = index"
      [class.legendHidden]="task.map?.hidden"
      style="margin-right: 7px"
    >
      <span [style.background-color]="task.map?.directions?.color" class="legend-item"></span>
      {{ task.vehicle.registrationNumber }}
    </span>
  </div>
</div>
